import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {CaseHospitalDTO} from '../models/case-hospital/CaseHospitalDTO';
import {CaseHospitalFileLinkDTO} from '../models/case-hospital/CaseHospitalFileLinkDTO';

@Injectable({
  providedIn: 'root'
})
export class CaseMedicalService {
  private caseHospitalUrl = environment.baseClmUrl + '/case-hospital';

  constructor(private httpClient: HttpClient) {
  }

  getCaseMedicalBy(caseId: number): Observable<CaseHospitalDTO> {
    return this.httpClient.get<CaseHospitalDTO>(`${this.caseHospitalUrl}/byCaseId?caseId=${caseId}`);
  }

  getCaseMedicalWithoutFilesBy(caseId: number): Observable<CaseHospitalDTO> {
    return this.httpClient.get<CaseHospitalDTO>(`${this.caseHospitalUrl}/byCaseId?caseId=${caseId}&excludeFiles=1`);
  }

  deleteCaseMedicalBy(caseId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.caseHospitalUrl + '/' + caseId);
  }

  saveCaseMedical(payload: CaseHospitalDTO): Observable<CaseHospitalDTO> {
    return this.httpClient.post<CaseHospitalDTO>(`${this.caseHospitalUrl}`, payload);
  }

  /*
    Case Medical Includes any Sub-Class e.g (Hospital, Pharmacy etc)
   */
  createDocument(payload: CaseHospitalFileLinkDTO): Observable<CaseHospitalFileLinkDTO> {
    return this.httpClient.post<CaseHospitalFileLinkDTO>(`${this.caseHospitalUrl}/document`, payload);
  }

  deleteDocument(caseHospitalId: number | bigint, fileId: bigint): Observable<CaseHospitalFileLinkDTO> {
    return this.httpClient.delete<CaseHospitalFileLinkDTO>(`${this.caseHospitalUrl}/document`, {
      params: {
        caseHospitalId: String(caseHospitalId),
        fileId: String(fileId)
      }
    });
  }
}
